module.exports = __webpack_public_path__ + "img/company-logo-light.4b917f18.svg";